// extracted by mini-css-extract-plugin
export default {"container":"CharactersGrid_container__BJM-c","noData":"CharactersGrid_noData__-B49M"};